import { t } from "@/i18n-js/instance";
import {
  segmentFilter,
  tagsFilter,
} from "@circle-react/components/SettingsApp/ManageMembers/TabContent/Filters/filterConfiguration";
import type { RenderFilter } from "@circle-react-shared/MemberFilters/types";
import { useIsProfileFieldsEnabled } from "@circle-react-shared/ProfileFields/useIsProfileFieldsEnabled";
import type { PopperOptions } from "@circle-react-uikit/Dropdown";
import { AddFilterDropdown } from "../AddFilterDropdown";
import { useDynamicFilterContext } from "../DynamicFilterContext";
import type { AddFilterArgs } from "../useDynamicFilters";
import { FiltersList } from "./FiltersList";
import { ProfileFieldUpgradeMessage } from "./ProfileFieldUpgradeMessage";

const crmCatgoryFilterNames = [segmentFilter.name, tagsFilter.name] as const;

interface AdminAreaFiltersListProps {
  label?: string;
  popperOptions?: PopperOptions;
}

export const AdminAreaFiltersList = ({
  label,
  popperOptions,
}: AdminAreaFiltersListProps) => {
  const isProfileFieldsEnabled = useIsProfileFieldsEnabled();
  const {
    platformFilters,
    profileFieldFilters = [],
    onAddFilter,
  } = useDynamicFilterContext();

  const [crmCategoryFilters, otherPlatformFilters] = platformFilters.reduce<
    [RenderFilter[], RenderFilter[]]
  >(
    (acc, filter) => {
      const isCrmFilter = crmCatgoryFilterNames.includes(filter.name);
      acc[isCrmFilter ? 0 : 1].push(filter);
      return acc;
    },
    [[], []],
  );

  return (
    <AddFilterDropdown label={label} popperOptions={popperOptions}>
      <div className="flex max-h-96 flex-col gap-y-4 overflow-y-auto">
        <FiltersList
          title={t("filters.crm")}
          filters={crmCategoryFilters}
          onAddFilter={onAddFilter}
        />
        <FiltersList
          title={t("filters.standard")}
          filters={otherPlatformFilters}
          onAddFilter={onAddFilter}
        />
        <ProfileFieldUpgradeMessage />
        {isProfileFieldsEnabled && (
          <FiltersList
            title={t("filters.custom")}
            filters={profileFieldFilters}
            onAddFilter={(params: AddFilterArgs) =>
              onAddFilter({ ...params, key: "profile_field" })
            }
          />
        )}
      </div>
    </AddFilterDropdown>
  );
};
